import React, { PureComponent } from 'react';
import { View } from 'react-native';
import {
    ChangeIndicatedCurrency,
    ChangeIndicatedPercent,
} from '../../../../src/components/common/number';
import DbkText from '@dbk/ui-text';
import {
    NavigationList,
    NavigationListItem,
} from '@dbk/ui-list';


class CurrencyList extends PureComponent {
    constructor(props) {
        super(props);
    }

    renderCurrencyList = (currencyList) => {
        return currencyList.map((item, index) => {
            return (

                <NavigationListItem hasArrow={false} style={{ backgroundColor: '#12213c', height: 100 , cursor: 'default'}} >

                    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', }}>

                        <div className="currency-nav-list-start">
                        <DbkText primary style={{fontSize:19}}>{item.currency}</DbkText>
                        </div>
                        <div className="currency-nav-list-column">
                            <ChangeIndicatedCurrency
                                value = {item.currencyTRDAmount}
                                onlyNegativeStyling
                            />
                        </div>
                        <div className="currency-nav-list-column">
                            <ChangeIndicatedCurrency
                                value={item.currencyAmtDestCcy}
                                onlyNegativeStyling
                            />
                        </div>
                        <div className="currency-nav-list-column">
                            <ChangeIndicatedPercent
                                value={item.currencyPercentage}
                            />
                        </div>

                    </View>

                </NavigationListItem>
            )

        });


    }
    renderHeader = (referenceCurrency,messages) => {  
        
        return (
            <div className="currency-tab-header-container">
                <div className="currency-list-header-ccy" > {messages['app.common.portfolio.fx.currency']}</div>

                <div className="currency-list-header">
                    <div className="currency-tab-list-header">{messages['app.portfolio.equassets.mktValue']}</div>
                    <div className="currency-tab-list-header">{"(" +messages['app.common.portfolio.fx.currency'] +")"}</div>
                </div>
                <div className="currency-list-header-market">
                    <div className="currency-tab-list-header">{messages['app.portfolio.equassets.mktValue']}</div>
                    <div className="currency-tab-list-header">{"(in "+ `${referenceCurrency}`+")"}</div>
                </div>
                <div className="currency-list-header-prct">{"%   "}</div>
            </div>);
    }

    render() {

        const currencyExposure = this.props.currencyChartData ? JSON.parse(this.props.currencyChartData) : null;
        const currencyArray = currencyExposure? currencyExposure.currencyAllocation : [];
        const referenceCurrency=this.props.referenceCurrency;
        const messages = this.props.messages; 
        return (

            <div>
                {this.renderHeader(referenceCurrency,messages)}
                <NavigationList style = {{ cursor: 'default'}} hasArrow={false} testID="list">
                    {this.renderCurrencyList(currencyArray)}
                </NavigationList>
            </div>);
    }


}


export default CurrencyList;
